/* eslint-disable react/prop-types */
import React from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, inkA } from '../tokens';

// Logo/code slot + title + optional location subtitle. Generic enough to reuse
// for tracks, series, accounts, etc.
const EntityCell = ({ logo, code, title, subtitle }) => {
  const theme = useTheme();
  const t = tokens(theme);
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 15, minWidth: 0 }}
    >
      <div
        style={{
          width: 92,
          height: 56,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {logo ? (
          <img
            src={logo}
            alt={code || ''}
            style={{
              display: 'block',
              maxWidth: '100%',
              maxHeight: 56,
              objectFit: 'contain',
            }}
          />
        ) : (
          <span
            style={{
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: '0.5px',
              color: inkA(theme, 0.66),
              textTransform: 'uppercase',
              lineHeight: 1.05,
            }}
          >
            {code}
          </span>
        )}
      </div>
      <div
        style={{
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <span
          title={title}
          style={{
            minWidth: 0,
            fontSize: '14.5px',
            fontWeight: 600,
            color: t.text,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
          }}
        >
          {title}
        </span>
        {subtitle ? (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 5,
              minWidth: 0,
              fontSize: '12.5px',
              fontWeight: 500,
              color: t.sub,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <Icon name="map-pin" size={12} color={t.primary} />
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {subtitle}
            </span>
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default EntityCell;
